<template>
  <transition name="product">
    <div class="scan-detail">
      <van-nav-bar
        @click-left="onClickLeft"
        title="企业关注"
        left-text="返回"
        left-arrow
      >
      </van-nav-bar>

    </div>
  </transition>
</template>

<script>
export default {
  methods:{
    onClickLeft(){
      this.$router.back();
    }
  },
  created() {
    
  },
};
</script>

<style lang="scss" scoped>
.scan-detail {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  overflow-x: hidden;
  background-color: rgb(247, 248, 250);
  z-index: 1;
}
</style>